import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, HideScrollbar, LineClamp } from '../../../global/commonStyle';

interface Props {
  isActive?: boolean;
}

const ModalMain = styled.div`
  padding: var(--space-0);
  width: 632px;
  ${mobile_xl(css`
    width: 100%;
  `)}
`;

const ModalContent = styled.div`
  position: relative;
  ${AlignCenter}
  gap: var(--space-2);
  padding: var(--space-16) var(--space-2);
  svg {
    cursor: pointer;
  }
  .arrows-icon {
    path {
      stroke: var(--text-primary);
    }
  }
`;

const Bottom = styled.div`
  max-width: 100rem;
  padding: var(--space-0) var(--space-16) var(--space-16) var(--space-16);
  ${HideScrollbar}
`;

const List = styled.div`
  white-space: nowrap;
  display: flex;
  position: relative;
  gap: var(--space-4);
`;

const Figure = styled.div<Props>`
  height: 44px;
  padding: var(--space-2);
  border: 2px solid transparent;
  &:focus {
    border: 2px solid var(--brand-primary);
  }
  &:active {
    border: 2px solid var(--brand-primary);
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      border: 2px solid var(--brand-primary);
    `}
`;

const Datetime = styled.div`
  display: flex;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-10);
  border-radius: var(--border-radius-4);
  background: var(--neutral-tooltip-secondary);
  position: absolute;
  bottom: 26px;
  left: 38px;
  p {
    margin: var(--space-0);
    color: var(--text-white);
    ${LineClamp(1)}
    ${Typography.body_sm_medium}
  }
`;
export { ModalContent, ModalMain, Bottom, List, Figure, Datetime };
